import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formatAmount, isEmpty } from "../../Util/UtilHelper";
import MUITypography from "../../Components/MUITypography";
import { VM_Colors } from "../../Styles/VMStyles";
import StorageFactory from "../../Util/StorageFactory";
import {
  ROUTE_INVOICE_HISTORY,
  SESSION_USER_COUNTRY_DATA_KEY,
} from "../../Util/VMConstants";

// Invoice status mapping
const invoiceStatusConfig = {
  true: { label: "Cleared", color: "success" },
  false: { label: "Pending", color: "warning" },
};

export const PaymentReminders = ({ data = [] }) => {
  const navigate = useNavigate();
  const sessionFactory = new StorageFactory('session');
  const currencySymbol = sessionFactory.get(SESSION_USER_COUNTRY_DATA_KEY)?.currency_symbol || '₹';



  const totalPending =  isEmpty(data[0]?.total_pending_invoice_count) ? 0 : data[0]?.total_pending_invoice_count ;

  return (
    <Card variant="outlined" sx={{ borderRadius: 3 }}>
      <CardContent>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MUITypography variant="h4" gutterBottom sx={{fontWeight:700}}>
          Payment Reminders
        </MUITypography>
        </Box>

        {/* Summary */}
        <Box
          bgcolor={VM_Colors.error_transparent}
          color="error.dark"
          p={1.5}
          textAlign="center"
          borderRadius={2}
          mb={2}
        >
          <MUITypography variant="h5" fontWeight="600"  sx={{color:VM_Colors.black}}>
            Total Pending Invoices: {totalPending}
          </MUITypography>
        </Box>

        {/* Table */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: "primary.main" }}>
                {[
                  "Invoice ID",
                  "Customer",
                  "Grand Total",
                  "Pending Amount",
                  "Payment Mode",
                  "Status",
                ].map((head) => (
                  <TableCell key={head} sx={{ color: "white", fontWeight: 600 }}>
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, i) => {
                const enquiry = row.enquiry_info?.[0] || {};
                return (
                  <TableRow
                    key={row.invoice_id ?? i}
                    onClick={() => navigate("/" + ROUTE_INVOICE_HISTORY)}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        bgcolor: "action.hover",
                      },
                    }}
                  >
                    {/* Invoice ID */}
                    <TableCell>{row.invoice_id}</TableCell>

                    {/* Customer */}
                    <TableCell>
                      {enquiry.name || "-"} <br />
                      <Typography variant="caption" color="text.secondary">
                        {enquiry.phone_no || ""}
                      </Typography>
                    </TableCell>

                    {/* Grand Total */}
                    <TableCell>{formatAmount( row.final_payable_amount,currencySymbol) }</TableCell>

                    {/* Pending */}
                    <TableCell>{formatAmount( row.pending_amount,currencySymbol)}</TableCell>

                    {/* Payment Mode */}
                    <TableCell>{row.payment_mode}</TableCell>

                    {/* Status */}
                    <TableCell>
                      <Chip
                        label={invoiceStatusConfig[row.is_invoice_clear]?.label || "Pending"}
                        color={invoiceStatusConfig[row.is_invoice_clear]?.color || "warning"}
                        size="small"
                      />
                    </TableCell>


                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};
